import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import GlobalSettings from './GlobalSettings.js';
import { GlobalStateContext } from './GlobalStateContext.js';
import '../styles/Head.css';
import '../styles/bubbleStyle.css';
import help from '../images/QuestionWhiteSmall.png';
import pens from '../images/Stifte.png';
import RadioButtonGroup from './Radiobuttons.js';
import SelectComponent from './Select.js';
import TextArea from './TextArea.js';
import PopupHelp from './PopupHelp.js';
import PopupMessage from './PopupMessage.js';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import PageInvalid from './PageInvalid.js';

const Questions = () => {
    const { 
        surveyCode,
        questionset_id,
        setQuestionsetId,
        participation,
        setParticipation,
        token,
        setToken,
        answers,
        surveyName,
        setSurveyName,
        surveyTitle,
        setSurveyTitle,
        openquestion_id,
        setOpenquestionId,
        completeSet,
        setCompleteSet,
        answerSet,
        setAnswerSet,
        closedQuestion_id,
        setClosedQuestionId,
        valid,
        setValid, 
        surveyId,
        setSurveyId, 
        participationCode, 
        surveyMode
    } = useContext(GlobalStateContext);

    const [state, setState] = useState({
        number: 1,
        title: [],
        topic: [],
        quest: [],
        from: [],
        thematicarea: [],
        question: [],
        completeSet: [],
        answerpossibility: [],
        answers: [],
        answerSet:[],
        textAnswer:"",
        selectedOption: "",
        selectedValue:"",
        helpButton: false,
        helptext: [],
        currentIndex:0,
        nextIndex: 0,
        helpVisibility: false, 
        messageVisibility: false,
        maxIndex:0,
        prevSelectedValue: null,
        surveyCompleted: false,
        isLoading: true
    });

    const navigate = useNavigate();

    const [isAnimating, setIsAnimating] = useState(false);
    const [animationDirection, setAnimationDirection] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const commonPromises = [
                    fetch('/api/title/' + GlobalSettings.languageId).then(res => res.json()),
                    fetch('/api/from').then(res => res.json()),
                    fetch('/api/questions/' + surveyId).then(res => res.json())
                ];
        
                // Falls participationCode vorhanden ist, entsprechenden fetch-Aufruf hinzufügen
                let hasParticipationCode = false;
                if (participationCode && participationCode.length>1) {
                    hasParticipationCode = true;
                    commonPromises.push(fetch(`/api/surveyDone/${encodeURIComponent(participationCode)}`).then(res => res.json()));
                }
        
                // Warten Sie auf alle Promises
                const results = await Promise.all(commonPromises);

                const topicRes = results[0];
                const fromRes = results[1];
                const questionsRes = results[2];
                const surveyCompletedRes = hasParticipationCode ? results[3] : 0;
        
                setCompleteSet(questionsRes);
                if(GlobalSettings.debugMode==='on'){
                    console.log("CompSet", completeSet);
                    console.log("CompRes", surveyCompletedRes);
                }
                
                setState(prevState => ({
                    ...prevState,
                    surveyCompleted: surveyCompletedRes,
                    topic: topicRes,
                    from: fromRes,
                    completeSet: questionsRes,
                    isLoading: false
                }));
            } catch (error) {
                console.log(error);
                setState(prevState => ({
                    ...prevState,
                    isLoading: false
                }));
            }
        };

        fetchData();
    }, [GlobalSettings.languageId, surveyCode, participationCode]);

    const handleSelectedValueChange = (selectedValue, isManual=true, checkbox=false) => {
       // console.log("handleSelectedValueChange called with:", selectedValue, isManual, checkbox);
        setState(prevState => ({
            ...prevState,
            selectedValue: selectedValue,
            checkbox: checkbox ?? prevState.checkbox
        }));

        

        const answerValues = {
            question_id: state.completeSet[state.currentIndex].Question_ID,
            question: state.completeSet[state.currentIndex].Question,
            questionType: state.completeSet[state.currentIndex].Question_Type,
            questionTypeId : state.completeSet[state.currentIndex].Question_TypeID,
            answerValue: selectedValue,
            answerPossibilities: state.completeSet[state.currentIndex].AnsPoID,
            survey_code: state.completeSet[state.currentIndex].Survey_Code,
            token: participationCode,
            survey_id: state.completeSet[state.currentIndex].Survey_ID,
            answerText: state.completeSet[state.currentIndex].Value,
            questionset_id: state.completeSet[state.currentIndex].QuestionSet_ID,
            textAnswer: state.textAnswer,
            checkbox: checkbox
        };

        
/*
        const updatedAnswers = state.answerSet.map(answer => {
            if (answer.question_id === answerValues.question_id) {
                return answerValues;
            } else {
                return answer;
            }
        });*/
        //console.log("Vor Update: answerSet =", state.answerSet);

        const updatedAnswers = state.answerSet.map(answer => {
            if (answer.question_id === answerValues.question_id) {
                return { ...answer, ...answerValues, checkbox }; // `checkbox` explizit setzen
            } 
            //console.log("Neue Werte:", answerValues);
            return answer;
        });

        if (!updatedAnswers.some(answer => answer.question_id === answerValues.question_id)) {
            updatedAnswers.push(answerValues);
        }

        setState(prevState => ({
            ...prevState,
            answerSet: updatedAnswers
        }));
        
        if(isManual === false)
            handleProgress('forward', isManual);
    };

    const handleHelp = () => {
        setState(prevState => ({ ...prevState, helpVisibility: true }));
    }

    const handleCloseHelp = () => {
        setState(prevState => ({ ...prevState, helpVisibility: false }));
    }

    const handleMessage = () => {
        setState(prevState => ({ ...prevState, messageVisibility: true }));
    }

    const handleCloseMessage = () => {
        setState(prevState => ({ ...prevState, messageVisibility: false }));
    }
// TODO


    const handleProgress = (direction, isManual = false) => {
        let newIndex;
        let maxIndex = state.completeSet.length - 1;
        isManual = true;
        if (direction === 'forward') {
            if (isManual) {
                const currentQuestion = state.completeSet[state.currentIndex];
                const isAnswerRequired = currentQuestion.Question_Type !== 'offen';
                const currentAnswerSet = state.answerSet[state.currentIndex] || -1 ;
               // const isAnswerValid = state.selectedValue !== "" && currentAnswerSet.answerValue > 0;
               /* if(GlobalSettings.debugMode==='on')
                    {console.log("Valid Answer", "AnswerReq", isAnswerRequired,"CurSetAnsVal", currentAnswerSet, "selVal", state.selectedValue, "surveymode", surveyMode.length);
                       
                    }*/
                
                // Ensure that an undefined currentAnswerSet is handled as invalid
                if(isAnswerRequired === true){ // geschlossene Frage
                    const isAnswerValid = state.selectedValue !== "" && currentAnswerSet.answerValue > 0;
                    if (isAnswerRequired && !isAnswerValid && surveyMode.length===0)  {
                        handleMessage();
                        return; // Stop further progress if validation fails
                    }
                }
                else{
                    const isAnswerValid = state.selectedValue !== "";
                    if(GlobalSettings.debugMode==='on')
                        {console.log("Valid Answer", isAnswerValid, "AnswerReq", isAnswerRequired,"CurSetAnsVal", currentAnswerSet, "selVal", state.selectedValue.trim() !== "", "surveymode", surveyMode.length);
                          }
                    if ((state.selectedValue.trim() === "" && !isAnswerRequired) && surveyMode.length === 0) {
                        handleMessage();
                        setIsAnimating(false)
                        return; // Stop further progress if validation fails
                    }    
                }
                newIndex = state.currentIndex + 1 > maxIndex ? state.currentIndex : state.currentIndex + 1;
                setAnimationDirection('right');
                setIsAnimating(false);
                setTimeout(() => {
                    setState(prevState => ({ ...prevState, currentIndex: newIndex }));
                    setIsAnimating(false);
                },300); // Duration of the slide-in animation*/
            }
            else{
            newIndex = state.currentIndex + 1 > maxIndex ? state.currentIndex : state.currentIndex + 1;
            setAnimationDirection('right');
            setIsAnimating(false);
            setTimeout(() => {
                setState(prevState => ({ ...prevState, currentIndex: newIndex }));
                setIsAnimating(false);
            },300); // Duration of the slide-in animation
        }
        } else if (direction === 'backward') {
            newIndex = state.currentIndex - 1 < 0 ? 0 : state.currentIndex - 1;
            setAnimationDirection('left');
            setIsAnimating(false);
            setTimeout(() => {
                setState(prevState => ({ ...prevState, currentIndex: newIndex }));
                setIsAnimating(false);
            },300); // Duration of the slide-in animation
        }
    
        if (state.currentIndex === maxIndex) {
            setAnswerSet(state.answerSet);
            setIsAnimating(false);
        }
        
        // Start animation
        
    
        
    };
    
    
    

    const nextPath = (path) => {
        navigate(path);
    };
    const findMatchingValue = (currentQuestionId, answerSet, key) => {
        //console.log(`Suche question_id: ${currentQuestionId} in answerSet`, answerSet);
    
        const matchingItems = answerSet.filter(item => item.question_id === currentQuestionId);
       // console.log("Gefundene Einträge:", matchingItems);
    
        if (matchingItems.length === 0) {
          //  console.log(`Kein Eintrag mit question_id ${currentQuestionId} gefunden.`);
            return false;
        }
    
        const matchingItem = matchingItems[0]; // Falls es mehrere gibt, nehme das erste
        if (!(key in matchingItem)) {
          //  console.log(`Key "${key}" existiert nicht in`, matchingItem);
            return false;
        }
    
      // console.log(`Gefunden: ${key} =`, matchingItem[key]);
        return matchingItem[key];
    };

    /*
    const findMatchingValue = (currentQuestionId, answerSet, key) => {
        const matchingItem = answerSet.find(item => item.question_id === currentQuestionId);
        //const matchingItem = answerSet.find(item => item.question_id === currentQuestionId);
    
    if (!matchingItem) {
        console.log(`Kein Eintrag mit question_id ${currentQuestionId} gefunden.`);
        return false;
    }

    if (!(key in matchingItem)) {
        console.log(`Key "${key}" existiert nicht in`, matchingItem);
        return false;
    }

    console.log("Gefunden:", matchingItem);
    return matchingItem[key];
      //  return matchingItem ? matchingItem[key] : null;
    };
*/
    const formElementMapping = {
        select: SelectComponent,
        textarea: TextArea,
        default: RadioButtonGroup
    };

    const forBackButton = () => {
        let maxIndex = state.completeSet.length - 1;
        if(GlobalSettings.debugMode==='on')
            console.log("CurIX", state.currentIndex);
        if (state.currentIndex === 0 ){
            return (
                <div style={{ userSelect: "none" }}>
                    <div className='bubbleBack'>
                        
                    </div>
                    <div className='bubbleForward'>
                        <button className='btnBubble' onClick={() => handleProgress('forward' ,false)}>
                            <FontAwesomeIcon className='btnBubbleForward fa-pull-right' size={'1x'} icon={faArrowRightLong} />
                            <span className='bubbleSpanRight'>weiter</span>
                        </button>
                    </div>
                </div>
            );
        }
        else if (state.currentIndex !== maxIndex && state.selectedOption === '') {
            return (
                <div style={{ userSelect: "none" }}>
                    <div className='bubbleBack'>
                        <button className='btnBubble' onClick={() => handleProgress('backward')}>
                            <FontAwesomeIcon size={'1x'} className='btnBubbleBackward' icon={faArrowLeftLong} title="Zurück" />
                            <span className='bubbleSpanLeft'>zurück</span>
                        </button>
                    </div>
                    <div className='bubbleForward'>
                        <button className='btnBubble' onClick={() => handleProgress('forward',false)}>
                            <FontAwesomeIcon className='btnBubbleForward fa-pull-right' size={'1x'} icon={faArrowRightLong} />
                            <span className='bubbleSpanRight'>weiter</span>
                        </button>
                    </div>
                </div>
            );
        } 
        else if (state.currentIndex === maxIndex) {
            setAnswerSet(state.answerSet);
            return (
                <div style={{ userSelect: "none" }}>
                    <div className='bubbleBack'>
                        <button className='btnBubble' onClick={() => handleProgress('backward')}>
                            <FontAwesomeIcon className='btnBubbleBackward' size={'1x'} icon={faArrowLeftLong} title="Zurück" />
                            <span className='bubbleSpanLeft'>zurück</span>
                        </button>
                    </div>
                    <div className='bubbleForward'>
                        <button className='btnBubble'>
                            <Link to="/info">
                                <FontAwesomeIcon className='btnBubbleForward fa-pull-right' size={'1x'} icon={faArrowRightLong} onClick={() => handleProgress('forward',false)} /><span className='bubbleSpanRight'>Umfrage abschließen</span></Link>
                        </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div style={{ userSelect: "none" }}>
                    <div className='bubbleBack'>
                        <button className='btnBubble' onClick={() => handleProgress('backward')}>
                            <FontAwesomeIcon className='btnBubbleBackward' icon={faArrowRightLong} size={'1x'} />
                            <span className='bubbleSpanLeft'>Zurück</span>
                        </button>
                    </div>
                    <div className='bubbleForward'>
                        <button className='btnBubble' onClick={() => handleProgress('forward',false)}>
                            <FontAwesomeIcon className='btnBubbleForward' icon={faArrowRightLong} />
                            <span className='bubbleSpanRight'>weiter</span>
                        </button>
                    </div>
                </div>
            );
        }
    };

    if (state.isLoading) {
        return <div>Loading...</div>;
    }

    if ((!token || state.surveyCompleted) && (!surveyMode)) {
        return (
            <div>
                <PageHeader />
                <PageInvalid />
                <PageFooter />
            </div>
        );
    } else if (token || surveyMode) {
        if (state.completeSet.length === 0) {
            return (
                <div className='App'>
                    <div className='quest'>
                        <div className="headLine_1"><h3>Hinweis!</h3></div>
                        <div className="headLine_2"><h3>Es wurden noch keine Fragen eingetragen.</h3></div>
                    </div>
                    <PageFooter />
                </div>
            );
        }

        if (state.completeSet.length > 0) {
            const currentElement = state.completeSet[state.currentIndex].Question_Formelement;
            const FormElementComponent = formElementMapping[currentElement] || formElementMapping.default;

            const prevSelectedValue = state.answerSet.length > 0 ? findMatchingValue(state.completeSet[state.currentIndex].Question_ID, state.answerSet, "answerValue") : null;
            const prevSelectedCheckbox = findMatchingValue(state.completeSet[state.currentIndex].Question_ID, state.answerSet, "checkbox"); 
          //  console.log("CB",prevSelectedCheckbox);
            //console.log(state.answerSet);
            if(GlobalSettings.debugMode==='on')
                console.log(state.answerSet);
            return (
                <div>
                    <PageHeader headerText={surveyTitle} surveyName={surveyName} mode={surveyMode} />
                    <div className="questionBody">
                        <div className="bubbleInactive ">
                            <div className="bubbleNoText left"></div>
                        </div>
                        
                        <div className={`bubbleActive`} >    
                            <div className={`bubbleText ${isAnimating ? (animationDirection === 'right' ? 'bubble-slide-in-right' : 'bubble-slide-in-left') : ''}`}>
                                <div className='bubbleHeader'>
                                    <div className="bubbleThematicArea">
                                        {state.completeSet[state.currentIndex].ThematicArea_Name}
                                    </div>
                                    <div className="bubbleHelp">
                                        <input type="image" src={help} className='help_icon' alt='help' onClick={handleHelp} />
                                    </div>
                                </div>
                                <div className="bubbleContent">
                                    <div className="bubbleQuestionText">
                                        {state.completeSet[state.currentIndex].Question}
                                    </div>
                                    <div className="bubbleAnswers">
                                        <FormElementComponent
                                            labels={(state.completeSet[state.currentIndex]?.Value ?? '').split(';')}
                                            values={(state.completeSet[state.currentIndex]?.AnsPoID ?? '').split(';')}
                                            prevSelectedValue={prevSelectedValue}
                                            prevSelectedCheckbox = {prevSelectedCheckbox}
                                            currentIndex={state.currentIndex}
                                            completeSet={state.completeSet[state.currentIndex]}
                                            onSelectedValueChange={handleSelectedValueChange}
                                        />
                                    </div>
                                </div>
                                <div className='bubbleFooter'>
                                    {forBackButton()}
                                </div>
                                
                            </div>
                            <div className='bubbleProgress'>{state.currentIndex+1} von {state.completeSet.length}</div>
                        </div>
                        <div className="bubbleInactive">
                            <div className="bubbleNoText right"></div>
                        </div>
                    </div>
                    <PageFooter progress={(state.currentIndex + 1) * (100 / state.completeSet.length)} />
                    {state.helpVisibility && (
                        <PopupHelp PopupHelpString={state.completeSet[state.currentIndex].HelpText} onClose={handleCloseHelp} />
                    )}
                     {state.messageVisibility && (
                        <PopupMessage popupMessageString={"Bitte wählen Sie eine Antwortmöglichkeit."} onClose={handleCloseMessage} />
                    )}
                </div>
            );
        } else {
            return (
                <div className='App'>
                    <div className='quest'>
                        <div className="headLine_3"><h3>Hinweis!</h3></div>
                        <div><br /><h3>Bitte füllen Sie die Felder vollständig aus!</h3></div>
                        <PageFooter />
                    </div>
                </div>
            );
        }
    }
    else {
        return ("auf Kies gefurzt");
    }
}

export default Questions;
